import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=a4716a2c&scoped=true"
import script from "./SalesInvoices.vue?vue&type=script&lang=js"
export * from "./SalesInvoices.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoices.vue?vue&type=style&index=0&id=a4716a2c&prod&lang=scss"
import style1 from "./SalesInvoices.vue?vue&type=style&index=1&id=a4716a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4716a2c",
  null
  
)

export default component.exports